module.exports = __webpack_public_path__ + "img/IGNIS-GLX-MENTOLATO.9a60f52b.png";